//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'

export default {
  name: 'AppHeaderMasthead',

  data() {
    return {
      showModal: false,
      showMenu: false,
      messageIndex: 0,
      messageInterval: null
    }
  },

  computed: {
    ...mapState('user', ['details']),
    ...mapGetters('user', ['isGuest', 'isSubscriber']),

    messages() {
      if (this.isUK) {
        return ['Now available exclusively at cultbeauty.co.uk'];
      }

      return this.isSubscriber
        ? ['Refer a Friend + Get $20*']
        : ['Over 50% Off Sitewide Ends Soon*']
    },

    menuClasses() {
      return {
        'is-open': this.showMenu
      }
    },

    isUK() {
      return this.$store.getters['ui/getHostname'].includes('co.uk')
    },
  },

  mounted() {
    this.showModal =
      this.isGuest && Boolean(window?.location?.hash === '#login')

    if (this.messages.length > 1) {
      this.initRotatingMessage()

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this.initRotatingMessage()
        } else {
          clearInterval(this.messageInterval)
          this.messageInterval = null
        }
      })
    }
  },

  methods: {
    initRotatingMessage() {
      this.messageInterval = setInterval(() => {
        this.messageIndex =
          this.messageIndex === this.messages.length - 1
            ? 0
            : this.messageIndex + 1
      }, 5000)
    }
  }
}
